'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdAddShoppingCart = function MdAddShoppingCart(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm12 24.6q0 0.4 0.3 0.4h19.3v3.4h-20q-1.3 0-2.3-1.1t-0.9-2.3q0-0.8 0.4-1.6l2.2-4.1-6-12.7h-3.4v-3.2h5.5q1.6 3.2 3.1 6.6 0.4 0.7 1.8 3.7t2.2 4.7h11.7q5.9-10.7 6.4-11.8l2.9 1.7-6.4 11.6q-0.9 1.7-2.9 1.7h-12.4l-1.5 2.8z m16.4 5.4q1.3 0 2.3 1t0.9 2.4-0.9 2.3-2.3 0.9-2.4-0.9-1-2.3 1-2.4 2.4-1z m-16.8 0q1.4 0 2.4 1t1 2.4-1 2.3-2.4 0.9-2.3-0.9-0.9-2.3 0.9-2.4 2.3-1z m6.8-15v-5h-5v-3.4h5v-5h3.2v5h5v3.4h-5v5h-3.2z' })
        )
    );
};

exports.default = MdAddShoppingCart;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/add-shopping-cart.js
// module id = 1221
// module chunks = 168707334958949